/**
 * Memory 管理 API
 * 提供记忆查看和删除功能
 *
 * Note: user_id 不再需要从前端传递，后端会从 token 中获取当前用户邮箱
 */

import { Http } from '@mygpt/app/http';

export interface MemoryItem {
  id: string;
  content: string;
  created_at?: string;
  updated_at?: string;
}

export interface MemoryListResponse {
  memories: MemoryItem[];
  total: number;
}

export interface DeleteAllResponse {
  deleted_count: number;
}

export interface MemoryListParams {
  page?: number;
  size?: number;
}

/**
 * 获取指定 Bot 下当前用户的所有记忆
 * @param botId Bot ID
 * @param params 分页参数（可选）
 */
export const getMemories = async (botId: string, params?: MemoryListParams): Promise<MemoryListResponse> => {
  const { get } = Http.use();
  const response = await get<MemoryListResponse>(`/memory/${botId}/list`, { params });
  return response.data;
};

/**
 * 删除单条记忆
 * @param memoryId 记忆 ID
 * @param botId Bot ID
 */
export const deleteMemory = async (memoryId: string, botId: string): Promise<void> => {
  const { delete: del } = Http.use();
  await del(`/memory/${botId}/${memoryId}`);
};

/**
 * 清除指定 Bot 下当前用户的所有记忆
 * @param botId Bot ID
 */
export const deleteAllMemories = async (botId: string): Promise<DeleteAllResponse> => {
  const { delete: del } = Http.use();
  const response = await del<DeleteAllResponse>(`/memory/${botId}`);
  return response.data;
};
